module.exports = __webpack_public_path__ + "img/420x239.531ca019.jpg";